/* AWA header (CLAUDE DRAFT) */
if (!customElements.get('awa-header')) {
  class AwaHeader extends HTMLElement {
    connectedCallback() {
      this.section = this.closest('.shopify-section') || this.parentElement;
      this.topbar = this.querySelector('[data-awa-topbar]');
      this.bar = this.querySelector('.awa-header__bar');
      this.drawer = this.querySelector('#awa-drawer');
      this.toggle = this.querySelector('[data-awa-open]');
      this.count = this.querySelector('.awa-header__count');
      this.measure = this.measure.bind(this);
      this.measure();
      window.addEventListener('resize', this.measure, { passive: true });
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(this.measure);
      this.setupDrawer();
      this.setupMega();
      this.setupTabs();
      this.watchCount();
    }

    measure() {
      const topH = this.topbar ? this.topbar.offsetHeight : 0;
      if (this.classList.contains('awa-header--sticky') && this.section) {
        this.section.style.setProperty('--awa-sticky-top', `-${topH}px`);
      }
      const h = this.bar ? this.bar.offsetHeight : this.offsetHeight;
      document.documentElement.style.setProperty('--header-height', `${h}px`);
    }

    setupDrawer() {
      if (!this.drawer || !this.toggle) return;
      const panel = this.drawer.querySelector('.awa-drawer__panel');
      const open = () => {
        this.drawer.hidden = false;
        requestAnimationFrame(() => this.drawer.classList.add('is-open'));
        this.toggle.setAttribute('aria-expanded', 'true');
        document.body.style.overflow = 'hidden';
        panel && panel.focus();
      };
      const close = () => {
        this.drawer.classList.remove('is-open');
        this.toggle.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
        setTimeout(() => { this.drawer.hidden = true; }, 250);
        this.toggle.focus();
      };
      this.toggle.addEventListener('click', open);
      this.drawer.querySelectorAll('[data-awa-close]').forEach((el) => el.addEventListener('click', close));
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !this.drawer.hidden) close(); });
    }

    // Top menu items with a drop-down: a click opens/closes the drop-down instead of loading the page.
    // Hover still opens it on desktop. Each drop-down has its own "Shop all" link for the page itself.
    setupMega() {
      const items = [...this.querySelectorAll('.awa-nav__item--parent')];
      const setOpen = (item, open) => {
        const link = item.querySelector(':scope > .awa-nav__link');
        item.classList.toggle('is-open', open);
        item.classList.toggle('is-closed', !open);
        if (link) link.setAttribute('aria-expanded', open ? 'true' : 'false');
      };
      const closeAll = (except) => items.forEach((it) => { if (it !== except && it.classList.contains('is-open')) setOpen(it, false); });
      items.forEach((item) => {
        const link = item.querySelector(':scope > .awa-nav__link');
        if (!link) return;
        link.setAttribute('aria-haspopup', 'true');
        item.addEventListener('mouseenter', () => { if (item._touch) return; item.classList.remove('is-closed'); link.setAttribute('aria-expanded', 'true'); });
        item.addEventListener('pointerdown', (e) => { item._touch = e.pointerType !== 'mouse'; });
        // a click-closed menu stays closed until the next hover or click; touch screens send a fake mouseleave after each tap, so ignore it there
        item.addEventListener('mouseleave', () => { if (item._touch) return; item.classList.remove('is-open'); link.setAttribute('aria-expanded', 'false'); });
        item.addEventListener('focusout', (e) => { if (!item.contains(e.relatedTarget)) { item.classList.remove('is-open'); link.setAttribute('aria-expanded', 'false'); } });
        link.addEventListener('click', (e) => {
          e.preventDefault();
          const willOpen = !item.classList.contains('is-open');
          closeAll(item);
          setOpen(item, willOpen);
          if (!willOpen && e.detail > 0) link.blur(); // mouse/touch close: drop focus so the panel doesn't reopen
        });
      });
      this.addEventListener('keydown', (e) => {
        if (e.key !== 'Escape') return;
        const item = e.target.closest('.awa-nav__item--parent');
        if (!item) return;
        setOpen(item, false);
        const link = item.querySelector(':scope > .awa-nav__link');
        link && link.focus();
      });
      document.addEventListener('click', (e) => { if (!this.contains(e.target)) closeAll(); });
    }

    // Brand sidebar: hovering, focusing or clicking a brand shows its series (a click no longer loads the brand page).
    setupTabs() {
      this.querySelectorAll('.awa-mega--tabs').forEach((mega) => {
        const tabs = [...mega.querySelectorAll('[data-mega-tab]')];
        const panes = [...mega.querySelectorAll('[data-mega-pane]')];
        let timer;
        const show = (t) => {
          tabs.forEach((x) => { x.classList.toggle('is-active', x === t); x.setAttribute('aria-current', x === t ? 'true' : 'false'); });
          panes.forEach((p) => { p.hidden = p.dataset.megaPane !== t.dataset.megaTab; });
        };
        tabs.forEach((t) => {
          t.addEventListener('mouseenter', () => { clearTimeout(timer); timer = setTimeout(() => show(t), 60); });
          t.addEventListener('mouseleave', () => clearTimeout(timer));
          t.addEventListener('focus', () => show(t));
          t.addEventListener('click', (e) => { e.preventDefault(); show(t); });
        });
      });
    }

    watchCount() {
      if (!this.count) return;
      const update = () => {
        const n = (this.count.textContent || '').trim();
        this.count.classList.toggle('is-empty', n === '' || n === '0');
      };
      update();
      new MutationObserver(update).observe(this.count, { childList: true, characterData: true, subtree: true });
    }
  }
  customElements.define('awa-header', AwaHeader);
}